import { create } from "zustand";
import api from '../apis/api';
import { getApproverSiteIds } from './MembershipStore';

export const useGroupStore = create((set) => ({
    groups: [],
    members: [],
    history: null,
    user_history: null,
    loading: false,
    refresh: false,
    set_refresh: (refresh) => set({ refresh }),
    set_loading: (loading) => set({ loading }),
    get_groups: async (siteIds) => {
        set({ loading: true })
        api.post('/group_provisions/groups', { siteId: siteIds.join(",") }).then(async r => {
            let sortedGroups = r.data.groups.sort((a, b) => {
                const nameA = a.groupName.toUpperCase()
                const nameB = b.groupName.toUpperCase()
                if (nameA < nameB) { return -1 }
                if (nameA > nameB) { return 1 }
                return 0;
            })
            const approverSiteIds = await getApproverSiteIds()
            sortedGroups.forEach(g => {
                g.isApprover = g.siteId.some(s => approverSiteIds.includes(s))
            })
            set({ groups: sortedGroups, members: r.data.members, loading: false })
        })
    },

    get_group_history: async (groupId) => {
        api.get('/group_provisions/history', { params: { id: groupId } }).then(r => {
            set({ history: r.data })
        })
    },
    clear_groups: async () => {
        set({ groups: [], members: [] })
    }
}))